import { useEffect, useState } from 'react';
import useIsPhone from './useIsPhone';

/**
 * Bank-account mobile layout: phone detection OR narrow viewport (portrait tablet).
 * Phone landscape (Transfers rule) still uses desktop accordion via useIsPhone only.
 */
export default function useRequirementsMobileLayout() {
  const isPhone = useIsPhone();
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const update = () => setIsNarrow(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isPhone || isNarrow;
}
